import React, {PureComponent} from "react";
import Input from "./Input";
import PhoneNumberMask from "../PhoneNumberInputMask";
import ErrorSpan from "../ErrorSpan";

export default class PersonalDataBlock extends PureComponent {
    constructor() {
        super(...arguments);

        this.handleChangeOnlyLetters = this.handleChangeOnlyLetters.bind(this);
        this.handleChangeIpn = this.handleChangeIpn.bind(this);
        this.handleBlurIpn = this.handleBlurIpn.bind(this);
        this.handleChangeEmail = this.handleChangeEmail.bind(this);
        this.handleBlurEmail = this.handleBlurEmail.bind(this);
        this.handleIfEmptyBlur = this.handleIfEmptyBlur.bind(this);
    }

    handleChangeOnlyLetters(attr, value) {
        if(!value.match(/^[а-яієї\/'\/"\-\s]*$/iu)) {
            this.props.updateErrors(attr, 'Тільки українські символи');
        } else {
            this.props.updateErrors(attr, null);
            this.props.onChange(attr, value);
        }
    }

    handleChangeIpn(attr, value) {
        if(!value.match(/^[0-9]{0,10}$/)) {
            this.props.updateErrors(attr, 'Поле має бути довжиною 10 символів і містити числа');
        } else {
            this.props.updateErrors(attr, null);
            this.props.onChange(attr, value);
        }
    }

    handleBlurIpn(attr, value) {
        if(!value.match(/^[0-9]{10}$/)) {
            this.props.updateErrors(attr, 'Невірний формат');
        }
        else {
            this.props.updateErrors(attr, null);
        }
    }

    handleBlurEmail(attr, value) {
        if(!value.match(/^(?=.*@\w{2,}\..*$)([^\sа-яА-ЯіїєІЇЄ,:;?!#%\*\(\)=\+\{\}\[\]\"\'\/\\\|]){4,}@(?=.*[.])(?=.*[.])(?=.*\.([a-zA-Z]{2,4}$))((?!mail\.ru)[^\s,:;!#%\*\(\)=\+\{\}\[\]\"\'\/\\\|])*$/) || value.length === 0) {
            this.props.updateErrors(attr, 'Некоректний email');
        } else {
            this.props.updateErrors(attr, null);
        }
    }

    handleChangeEmail(attr, value) {
        if(value.match(/[\sа-яА-ЯіїєІЇЄ,:;?!#%\*\(\)=\+\{\}\[\]\"\'\/\\\|]/)) {
            this.props.updateErrors(attr, 'Недопустиме значення');
        } else {
            this.props.updateErrors(attr, null);
            this.props.onChange(attr, value);
        }
    }

    handleIfEmptyBlur(attr, value) {
        if(!value.length) {
            this.props.updateErrors(attr, 'Недопустиме значення');
        } else {
            this.props.updateErrors(attr, null);
        }
    }

    render() {
        const {first_name, last_name, middle_name, ipn, email, phone_number, errors} = this.props;

        return (
            <div>
                <h4 className="my-4 font-weight-bolder">Персональні дані</h4>
                <div className="row">
                    <div className="col-sm-6">
                        <Input
                            attr={'last_name'}
                            value={last_name}
                            label="Прізвище"
                            placeholder='Введіть прізвище'
                            onChange={this.handleChangeOnlyLetters}
                            onBlur={this.handleIfEmptyBlur}
                            error={errors.last_name}
                            required={true}
                        />
                    </div>
                    <div className="col-sm-6">
                        <Input
                            attr={'first_name'}
                            value={first_name}
                            label="Ім'я"
                            placeholder="Введіть ім'я"
                            onChange={this.handleChangeOnlyLetters}
                            onBlur={this.handleIfEmptyBlur}
                            error={errors.first_name}
                            required={true}
                        />
                    </div>
                    <div className="col-sm-6">
                        <Input
                            attr={'middle_name'}
                            value={middle_name}
                            label='По батькові'
                            placeholder='Введіть по батькові'
                            onChange={this.handleChangeOnlyLetters}
                            onBlur={this.handleIfEmptyBlur}
                            error={errors.middle_name}
                            required={true}
                        />
                    </div>
                    <div className="col-sm-6">
                        <Input
                            attr={'ipn'}
                            value={ipn}
                            label='ІПН'
                            placeholder='Введіть ІПН'
                            onChange={this.handleChangeIpn}
                            onBlur={this.handleBlurIpn}
                            error={errors.ipn}
                            required={true}
                        />
                    </div>
                    <div className="col-sm-6">
                        <Input
                            attr={'email'}
                            value={email}
                            label='Електронна адреса'
                            placeholder='Введіть електронну адресу'
                            onChange={this.handleChangeEmail}
                            onBlur={this.handleBlurEmail}
                            error={errors.email}
                            required={true}
                        />
                    </div>
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label htmlFor="phone_number">
                                Номер телефону <span className="text-danger">*</span>
                            </label>
                            <PhoneNumberMask
                                attribute="phone_number"
                                value={phone_number}
                                invalid={Boolean(errors.phone_number)}
                                onChange={this.props.onChange}
                            />
                            {errors.phone_number && <ErrorSpan error={errors.phone_number}/>}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
